import styled, { css } from 'styled-components';
import { ThemeMode } from '../../../../../global-state/themeContext';
import { Typography } from '../../../../../stories/atoms';
import { ColumnFlexContainer } from '../../../../../stories/atoms/containerV2/ContainerV2';
import { muiTheme } from '../../../../../theme';
import { LayoutType } from './MobileChipLayout';

export const ChipsWrapper = styled.div<{ layout: LayoutType; gridColumns: number }>`
  display: grid;
  gap: ${({ theme: { spacing } }) => spacing(2)};

  ${({ layout, gridColumns, theme: { spacing } }) =>
    layout === 'grid'
      ? css`
          grid-template-columns: ${gridColumns ? `repeat(${gridColumns}, 1fr)` : `repeat(3, 1fr)`};
        `
      : css`
          display: flex;
          flex-wrap: wrap;
          gap: ${spacing(2)};
          & > div {
            flex: 1;
          }
        `}
`;

export const StyledChipWrapper = styled(ColumnFlexContainer)`
  width: 100%;
  background-color: ${({ theme: { color, palette } }) =>
    palette.mode === 'dark' ? color.backgroundSelectedHover : color.backgroundSelectedDark};
  & :first-of-type {
    flex: 1;
  }
`;

const getColor = (status: 'default' | 'positive' | 'negative', mode: ThemeMode) => {
  if (mode === 'dark') {
    return status === 'default'
      ? muiTheme.color.white
      : status === 'positive'
      ? muiTheme.color.success
      : muiTheme.color.error;
  } else {
    return status === 'default'
      ? muiTheme.color.primary
      : status === 'positive'
      ? muiTheme.color.validationGreen
      : muiTheme.color.red;
  }
};

export const StyledIndexTypography = styled(Typography)<{ status: 'default' | 'positive' | 'negative' }>`
  color: ${({ theme: { palette }, status }) => getColor(status, palette.mode)};
`;
